
import {forkJoin as observableForkJoin,  Observable, forkJoin } from 'rxjs';
import { Component, OnInit, ElementRef } from '@angular/core';
import { AddUserService } from "app/user/add-user/add-user.service";
import { UserResource } from "app/resources/user/user-resource";
import { RoleListResource } from "app/resources/role/role-list-resource";
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { RoleResource } from "app/resources/role/role-resource";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { NotificationsService } from "angular2-notifications";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from "app/services/utils.service";

@Component({
  selector: 'vbn-add-user',
  providers: [AddUserService],
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {

  addressParams: any;
  userResource: UserResource;
  roleListResource: RoleListResource;
  //adminProfileResource: AdminProfileResource;
  errorMessage: string;
  showSuccessAlert = false;
  private timer;
  saveErrors: boolean = false
  emailExist: boolean = false
  correctEmail: boolean = false;
  logoLang: any;
  selected_language: string = "ro";
  userRoleId = localStorage.getItem("_roleId");
  selectedClient = (localStorage.getItem("_sc") === null)? null:atob(localStorage.getItem("_sc"));



  constructor(
    private translate: TranslateService, 
    private addUserService: AddUserService, 
    private _router: Router, 
    private fb: FormBuilder, 
    private _notificationService: NotificationsService,
    private utilsService: UtilsService,
    private element: ElementRef) {
      this.userResource = new UserResource();
      this.userResource.role = new RoleResource();
      this.roleListResource = new RoleListResource();
      //this.adminProfileResource = new AdminProfileResource();
      this.logoLang = '0';
  }

  addForm = this.fb.group({
    firstName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    // 3-100 de caractere pentru a interzice introducerea de spatiu
    lastName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    companyName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    email: ['', [Validators.required, Validators.maxLength(100), Validators.email]],
    role: ['', [Validators.required]],
  })


  ngOnInit() {
    this.getUserRoles();
   // this.getAdminProfile();
  }

  getUserRoles() {
    this.addUserService.getUserRoles('/admin/role/getAll')
      .subscribe(
      response => {
        this.roleListResource = response;
      },
      error => this.errorMessage = <any>error);
  }

  onSubmit() {
    this.saveErrors = true

    if (!this.addForm.valid) {
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })

      //this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
      return
    }

    //Logo validation
    if(this.logoLang === '0' && this.userResource.logoStringRo == null){
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please upload the logo RO!')
      ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
      })
      return
  }
  if(this.logoLang === '1' && (this.userResource.logoStringRo == null || 
            this.userResource.logoStringEn == null ||
            this.userResource.logoStringFr == null ||
            this.userResource.logoStringDe == null)){
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please upload the logo for all languages!')
      ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
      })
      return
  }

    let checkEmail = this.userResource.email.indexOf('@');
    if (this.userResource.email.includes('.', checkEmail)) {
      this.correctEmail = false;
    }
    else {
      this.correctEmail = true;
      return;
    }

    /* if (this.adminProfileResource.profile == 'cms-photo-contest-front-end') {
      this.userResource.role = this.roleListResource.roles[0];
    } */

    this.userResource.firstName = this.utilsService.WhiteSpacesRemover(this.userResource.firstName);
    this.userResource.lastName = this.utilsService.WhiteSpacesRemover(this.userResource.lastName);
    this.userResource.isOneLogo = (this.logoLang === '0')? true: false;
    this.userResource.parrentUser = new UserResource();
    //this.userResource.parrentUser.email = this.selectedClient;
    const selectedRoleId = this.userResource.role.rid;
    console.log("====>>> selectedRoleId = ", selectedRoleId);
    console.log("====>>> roleListResource = ", this.roleListResource.roles);
    console.log("====>>> find = ", this.roleListResource.roles.find(x=> x.rid ==  selectedRoleId));
    this.userResource.role = this.roleListResource.roles.find(x=> x.rid ==  selectedRoleId);
    console.log("====>>> role = ", this.userResource.role);
    
    this.addUserService.addUser('/admin/user/createEdit',this.userResource)
      .subscribe(
      response => {
        this.userResource = response;
        this.showSuccessAlert = true;

         observableForkJoin(
          this.translate.get('Success'),
          this.translate.get('The user has been successfully added')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'success')
        })

        this._router.navigate([`/user-list`])
      },
      error => {
        this.emailExist = true;
      });
  }
  back() {
    this._router.navigate([`/user-list`])
  }

/*   getAdminProfile() {
    this.addUserService.getAdminProfile('/admin/profile/get')
      .subscribe(
      response => {
        this.adminProfileResource = response;
      },
      error => this.errorMessage = <any>error);
  } */

  changeListenerMainImage($event, lang): void {
    console.log("FFEFFF: ", $event)
    var file: File = $event.target.files[0];
    var myReader: FileReader = new FileReader();
    var image = this.element.nativeElement.querySelector('#documentInput'+lang);
    if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
      (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
      (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
      (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
      if (file.size < 1000000) {
        myReader.onloadend = (e: any) => {
          image.src = e.target.result;
          console.log("eddddddddddddddd", image);
          this.userResource["logoString"+lang] = e.target.result;
        }
        myReader.readAsDataURL(file);
      } else {
        forkJoin(
          this.translate.get('Image error'),
          this.translate.get('Image size is more than 1 mb!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    } else {
      forkJoin(
        this.translate.get('Image error'),
        this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
  }
  
}
